import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    if (!sessionStorage.getItem('ntiSelectedPlan')) {
      sessionStorage.setItem('ntiSelectedPlan', 'Basico');
    }
  }

  public choosePlan(plan: 'Basico' | 'Profesional'): void {
    sessionStorage.setItem('ntiSelectedPlan', plan);
  }

}
